import React from "react"
import { css } from "styled-components"
import { Block } from "../atoms/layout-primitives"
import VariantContainer, { IStyleVariant } from "../atoms/variant-container"
import ArticleCard, { IArticle } from "../molecules/article-card"
import CardSlider from "../molecules/card-slider"

interface IArticleCardGridProps {
  articles?: IArticle[]
  overflow?: "new-line" | "carousel"
  align?: "left" | "center"
  sliderVariants?: IStyleVariant | any[]
  dotsHeight?: string
}

/**
 * Displays a list of articles
 * @param articles - The articles to display
 * @param overflow - The row overflow behaviour
 * @param align - The alignment when overflow is set to "carousel"
 * @param sliderVariants - Variants for the slider
 * @param dotsHeight - Distance from the bottom of the carousel to the dots
 */
const ArticleCardGrid = ({
  articles = [],
  overflow = "new-line",
  align = "center",
  sliderVariants,
  dotsHeight = "32px",
}: IArticleCardGridProps) => {
  return (
    <Block>
      {articles.length > 0 && (
        <>
          {overflow === "carousel" && (
            <CardSlider
              variants={sliderVariants}
              align={align}
              dotsHeight={dotsHeight}
            >
              {articles.map((article, idx) => (
                <ArticleCard key={idx} article={article} />
              ))}
            </CardSlider>
          )}
          {overflow === "new-line" && (
            <VariantContainer
              variants={[
                css`
                  display: grid;
                  grid-template-columns: 1fr;
                  gap: 32px 0;
                `,
                css`
                  grid-template-columns: 1fr 1fr;
                  gap: 48px 24px;
                `,
                css`
                  grid-template-columns: 1fr 1fr 1fr;
                  gap: 48px 32px;
                `,
              ]}
            >
              {articles.map((article, idx) => (
                <ArticleCard key={idx} article={article} />
              ))}
            </VariantContainer>
          )}
        </>
      )}
    </Block>
  )
}

export default ArticleCardGrid
